import React from 'react';
import { replace } from 'react-router-redux';

import {ROUTE_RANGES} from '../../../constants/routeconstants';
import { connect } from 'react-redux';
import UserRoles from "../../../../../common/src/enums/UserRoles";
import {Link} from "react-router";
import * as AdminActions from "../../../actions/admin";
import {confirm} from "../../../utils/confirmDialog";
import {NotificationManager} from "react-notifications";
import UserFieldDataType from "../../../utils/enums/UserFieldDataTypeEnum";
import UserFieldElement from "../../reusable/UserFieldElement";
import moment from "moment";
import config from "../../../../../server/src/config";

class RangesPage extends React.Component {

    static getId() {
        return ROUTE_RANGES;
    }

    static getAllowedRoles() {
        return [UserRoles.MAIN_ADMIN]; // empty means allowed for all
    }

    constructor(props) {
        super(props);
        this.state = {
            editId: null,
            sortField: 'no',
        };
    }

    componentDidMount() {
        this.props.dispatch(AdminActions.getListItems('omraade'));
    }

    fields = [];
    render() {
        return this.props.ranges ? <div>
            <div className="sub-page-title">
                <h2>Områder</h2>
            </div>
            <div id="sub-page-content" className="sub-page-content">
                <table className="data-table">
                    <thead>
                    <tr>
                        <th scope="row" className="clickable" onClick={() => {this.setState({sortField: 'no'})}}>Områdenr</th>
                        <th className="clickable" onClick={() => {this.setState({sortField: 'name'})}}>Navn</th>
                        <th className="commands-column"></th>
                    </tr>
                    </thead>
                    <tbody>
                    {this.props.ranges.sort((s1, s2) => {
                        if (s1.Omraadenr === '') return 1;
                        if (s2.Omraadenr === '') return -1;
                        return this.state.sortField === 'no' ? (s1.Omraadenr < s2.Omraadenr ? -1 : 1) : s1.Navn.localeCompare(s2.Navn, 'da-DK')
                    }).toArray().concat(this.state.editId === 'new' ? [this.state] : []).map(range => {
                        return this.state.editId === null || (range.Omraadenr !== this.state.editId && typeof(range.editId) === 'undefined') ? <tr key={range.Omraadenr} id={'row-' + range.Omraadenr}>
                            <th scope="row">{range.Omraadenr}</th>
                            <td>{range.Navn}</td>
                            <td className="commands-column">
                                <i className={"fa fa-pencil " + (this.state.editId === null ? 'clickable' : 'disabled')} title="Rediger område" onClick={() => {
                                    if (this.state.editId === null) this.setState({
                                        editId: range.Omraadenr,
                                        Omraadenr: range.Omraadenr,
                                        Navn: range.Navn === null ? '' : range.Navn,
                                    });
                                }}/>
                                <i className={"fa fa-trash " + (this.state.editId === null ? 'clickable' : 'disabled')} title="Slet område" onClick={() => {
                                    if (this.state.editId === null) confirm("Slet", <span>Ønsker du at slette område <b>{range.Omraadenr}</b>?</span>, () => {
                                        this.props.dispatch(AdminActions.deleteListItem('omraade', range.Omraadenr, () => {
                                            NotificationManager.success(`Område ${range.Omraadenr} er slettet.`, "Sletning", 4000);
                                        }));
                                    });
                                }}/>
                            </td>
                        </tr> : <tr key="editor" id="row-editor" className="edit-row">
                            <th>
                                <UserFieldElement dataType={UserFieldDataType.regex} placeholder="" className="field50" containerClassName="display-inline-block"
                                                  name="Omraadenr" id="Omraadenr" maxLength="3" options={[{key: UserFieldDataType.regex.REGEX_OPTION_KEY , value: "[0-9]{3}"}]} value={this.state.Omraadenr}
                                                  autoCheckErrors={true} required={true} hideErrWhenFocused={true} hideErrUntilFocused={true}
                                    //errorWidth="auto" errorStyle={{container: {minHeight: 40, marginLeft:'-130px', zIndex: 99999}}}
                                                  onChange={this.onStandardFieldChange}
                                                  ref={instance => { this.fields[0] = instance; }}
                                />
                            </th>
                            <td>
                                <UserFieldElement dataType={UserFieldDataType.string} placeholder="" className="" containerClassName=""
                                                  name="Navn" id="Navn" maxLength="25" value={this.state.Navn}
                                                  autoCheckErrors={true} required={false} hideErrWhenFocused={true} hideErrUntilFocused={true}
                                                  onChange={this.onStandardFieldChange}
                                                  ref={instance => { this.fields[1] = instance; }}
                                />
                            </td>

                            <td className="commands-column">
                                <i className="fa fa-save clickable" title="Gem område" onClick={() => {
                                    this.save();
                                }}/>
                                <i className="fa fa-undo clickable" title="Annuller" onClick={() => {
                                    this.setState({editId: null});
                                }}/>
                            </td>
                        </tr>
                    })}
                    </tbody>
                </table>
            </div>
            <div className="sub-page-actions">
                <button className={"btn-primary" + (this.state.editId === null ? '' : ' disabled')} title="Opret nyt område" onClick = {() => {
                    if (this.state.editId === null) {
                        this.setState({
                            editId: 'new',
                            Omraadenr: '',
                            Navn:'',
                        });
                        setTimeout(function () {
                            const content = document.getElementById("sub-page-content");
                            content.scrollTop = content.scrollHeight;
                        });
                    }
                }}>Ny</button>
            </div>
        </div> : null;
    }

    onStandardFieldChange = (e) => {
        const stateVariable = e.target.name;
        this.setState({[stateVariable]: e.target.value});
    };

    allInputValid = () => {
        let result = true;
        this.fields.forEach((field) => {
            if (field && !field.isValid()) result = false;
        });
        return result;
    };

    save = () => {
        if (this.allInputValid()) {
            const rangeNr = this.state.Omraadenr;
            const entity = {
                Omraadenr: this.state.Omraadenr,
                Navn: this.state.Navn === '' ? null : this.state.Navn,
            };
            if (this.state.editId === 'new') this.props.dispatch(AdminActions.createListItemItem('omraade', entity, id => {
                NotificationManager.success(`Område ${id} er oprettet.`, "Oprettelse", 4000);

                this.setState({editId: null});
                setTimeout(function () {
                    const currentRow = document.getElementById("row-" + rangeNr);
                    currentRow.scrollIntoView(false);
                });
            }));
            else this.props.dispatch(AdminActions.updateListItem('omraade', this.state.editId, entity, id => {
                NotificationManager.success(`Område ${id} er opdateret.`, "Opdatering", 4000);
                this.setState({editId: null});
                setTimeout(function () {
                    const currentRow = document.getElementById("row-" + rangeNr);
                    currentRow.scrollIntoView(false);
                });
            }));
        }  else {
            this.fields.forEach((field) => {
                field.setState({visited: true});
            });
        }
    }
}

const mapStateToProps = (state) => ({
    ranges: state.admin.ranges,
});

export default connect(mapStateToProps)(RangesPage);



// WEBPACK FOOTER //
// ./src/client/src/components/pages/lists/RangesPage.js